/**
 * <sam-contact-form> — submits its <form> to Formspree (the form's `action`) without a page reload.
 *
 * Markup:
 *   <form action="https://formspree.io/f/…">
 *     <button type="submit" data-form-submit><span data-form-label>SEND</span>…</button>
 *   </form>
 *   [data-form-success]   hidden message shown after a successful send
 *
 * State classes (style these in CSS):
 *   button.loading   while sending
 *   button.success   after sending
 *   [data-form-success].visible
 *
 * Fires `sam:form-submitted` (bubbles) on success.
 */
class SamContactForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.button = this.querySelector('[data-form-submit]');
    this.success = this.querySelector('[data-form-success]');
    this.form?.addEventListener('submit', this.onSubmit.bind(this));
  }

  async onSubmit(e) {
    e.preventDefault();
    this.button.classList.add('loading');
    try {
      const response = await fetch(this.form.action, {
        method: 'POST',
        body: new FormData(this.form),
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error(`Form error ${response.status}`);
      this.showSuccess();
    } catch (err) {
      this.button.classList.remove('loading');
      const label = this.button.querySelector('[data-form-label]');
      if (label) label.textContent = this.getAttribute('error-label') || 'TRY AGAIN';
    }
  }

  showSuccess() {
    this.button.classList.remove('loading');
    this.button.classList.add('success');
    this.button.textContent = this.getAttribute('sent-label') || 'SENT';
    this.dispatchEvent(new CustomEvent('sam:form-submitted', { bubbles: true }));

    setTimeout(() => {
      Object.assign(this.form.style, { opacity: '0', transform: 'translateY(-10px)', transition: 'opacity 0.4s ease, transform 0.4s ease' });
      setTimeout(() => {
        this.form.style.display = 'none';
        if (!this.success) return;
        this.success.style.display = 'block';
        setTimeout(() => this.success.classList.add('visible'), 10);
      }, 400);
    }, 800);
  }
}

if (!customElements.get('sam-contact-form')) customElements.define('sam-contact-form', SamContactForm);
